import type { FC, PropsWithChildren } from 'react';
import { MdxProvider } from '@anywayseo/tools';


const RootWrapper: FC<PropsWithChildren> = ({ children }) => {
  return <MdxProvider>{children}</MdxProvider>;
};

export default RootWrapper;
